import React from "react";
import { useRouter } from "next/router";
import CustomModalLayout from "./../../../../../web/Auth/CustomModalLayout";
import { Button } from "./../../../../../../shadcn/components/ui/button";

export interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  primaryButtonLabel?: string;
  onPrimaryAction?: () => void;
}

const ErrorModal = ({
  open,
  onClose,
  title = "Something Went Wrong",
  message = "We're experiencing a server issue while fetching your details. This may be due to a temporary error or a connection timeout. Please try again, or contact support if the problem persists.",
  primaryButtonLabel = "Dashboard",
  onPrimaryAction,
}: ErrorModalProps) => {
  const router = useRouter();

  const handlePrimaryClick = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
    } else {
      router?.replace("/");
    }
    onClose();
  };

  return (
    <CustomModalLayout
      open={open}
      onClose={onClose}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4  max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[243px]">
        <div className="flex flex-col gap-4">
          <h2 className="font-semibold text-lg text-brand-textBlack text-center">
            {title}
          </h2>
          <p className="text-sm text-brand-orange text-center">{message}</p>
        </div>
        <Button className="mt-6" onClick={handlePrimaryClick}>
          {primaryButtonLabel}
        </Button>
      </div>
    </CustomModalLayout>
  );
};

export default ErrorModal;
